class Common {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const toggleHeaderMenu = () => {
      $('.l-header').toggleClass('is-open');
      $('body').toggleClass('is-fixed');
    };

    $('.hn-btn').on('click', toggleHeaderMenu);

    const spMq = window.matchMedia('(max-width: 767px)');
    $('.anchor-btn').on('click', function () {
      if (spMq.matches) {
        toggleHeaderMenu();
      }
    });
  }
}